import styled from 'styled-components';

const NavbarWrapper = styled.div`
    padding: 20px 40px;
    background: #fff;    
    box-shadow: 0 0.63158rem 1.47368rem 0 rgb(0 0 0 / 10%);
    .navbar-brand {
        font-size: 16px;
        font-weight: 900;
        color: #333;
        img {
            width: 100px;
        }
    }
    .nav-item {
        margin: 0px 10px;
        .nav-link {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            cursor: pointer;
            font-weight: 600;
            &:hover {
                color: #0d6efd;
            }
        }
        .btn {
            font-size: 14px;
            font-weight: 600;
            padding: 7px 20px;
            background: #000;
            border-color: #000;
            a {
                color: #fff;
                text-decoration: none;
            }
            &:hover {
				background: #fff;
				a {
					color: #000;
					text-decoration: none;
				}
			}
            @media (max-width: 1000px) {
                margin-top: 10px;
            }
        }
    }
    @media (max-width: 1000px) {
        padding: 20px 20px;
    }
`;

export { NavbarWrapper }